import {Injectable} from 'ng-metadata/core';

@Injectable()
export class CitationLinkerService {
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/citationLinker/citationLinker.service.ts